import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Modal,
  Grid,
  RadioGroup,
  Stack,
  Pagination,
  FormControl,
  FormControlLabel,
  Radio,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import { TextFieldSearch } from "./fieldText";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Swal from "sweetalert2";
import dayjs from "dayjs";

import { ModalHeader } from "./modalHeader";
import SalaryComponentCard from "../features/payment/salaryComponentCard";
import PoprchModal from "../features/payment/popSearch";
import FormSalary from "../features/payment/formSalart";

export default function AddModalProdcut({
  formda,
  children,
  setFormda,
  open,
  setOpen,
  callback,
  updateflat,
  setUpdateFlag,
  addUpdateApi,
  value,
}) {
  //   const [pagination, setPagination] = useState({ page: 1, total: 10 });
  // const [search, setSearch] = useState("");

  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);

  const struct = {
    empId: "",
    componentDetails: [],
  };

  const [addCompError, setAddCompError] = useState({
    empId: false,
    componentName: false,
    amount: false,
    percentage: false,
  });

  const compErrorStruct = {
    empId: false,
    componentName: false,
    amount: false,
    percentage: false,
  };

  const [cardValue, setCardValue] = useState(null);
  const [radioType, setRadioType] = useState("amount");

  const componentStruct = {
    componentName: "",
    amount: "",
    percentage: "",
  };

  const [component, setComponent] = useState(componentStruct);
  useEffect(() => {
    console.log("setFormda", formda);

    if (open == false) {
      setUpdateFlag(false);
    }
    // if(open==true && formda?.empId){
    //     setFormda({ ...formda, empId: formda.empId })
    //     setSearchvalue(formda?.employeeName)
    // }
    // if(open==false){

    // }
  }, [open]);
  const onClose = () => {
    setOpen(false);
    setFormda(null);
    setSearchvalue("");
    setAddCompError(compErrorStruct);
  };
  const totalAmount = () => {
    let sum = 0;
    if (formda?.componentDetails?.length) {
      formda.componentDetails.forEach((item) => {
        sum += Number(item.amount || 0);
      });
    }
    return sum.toFixed(2);
  };


  const titleMap = {
    SalaryComponents: "Salary Components",
    incentive: "Salary Incentive",
    Deductions: "Deductions",
    otherAllowence: "Other Allowance",
  };

  useEffect(() => {
    if (open) {
      setFormda({
        empId: "",
        componentDetails: [],
      });
    }
  }, [open, value]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "60%", md: "50%", lg: "40%", xl: "40%" },

          overflowY: "auto",
          // height: "75vh",
          height: value === "incentive" ? {xs:"85vh", sm:"90vh"} : "auto",
          borderRadius: "10px",
          position: "absolute",
          left: { xs: "2%", sm: "25%", md: "25%", lg: "30%", xl: "30%" },

          top: { sm: "5%", xs: "5%" },
        }}
      >
        <ModalHeader
          title={titleMap[value] || "Payment Structure"}
          onClose={(data) => {
            setOpen(data);
            setFormda({ ...struct });
            setSearchvalue("");
            setAddCompError(compErrorStruct);
          }}
        />
        <Grid container sx={{}}>
          <Grid xs={12}>{children}</Grid>
          <Grid item xs={12}>
            <Divider
              sx={{
                background: (theme) => theme.palette.primary.main,
                width: "100%",
                height: "1.5px",
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ padding: "8px 20px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                // padding: "0 10px 0 5px",
                px: "10px",
              }}
            >
              <Typography
                component="span"
                fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                color={"primary.main"}
              >
                {value == "SalaryComponents"
                  ? "Component Name"
                  : value == "incentive"
                  ? "Incentive Name"
                  : value == "Deductions"
                  ? "Deduction Name"
                  : value == "otherAllowence"
                  ? "Allowance Name"
                  : ""}
              </Typography>
              <Typography
                fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                component="span"
                color={"primary.main"}
              >
                Amount
              </Typography>
            </Box>
            <Box
              sx={{
                height: "32vh",
                overflowY: "auto",
              }}
            >
              {formda?.componentDetails?.map((item, index) => {
                return (
                  <SalaryComponentCard
                    key={index + "purchaseitem"}
                    index={index}
                    value={value}
                    item={item}
                    arr={formda}
                    setFormData={setFormda}
                  />
                );
              })}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                paddingX: "30px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Total Amount: &nbsp;
              </Typography>
              <Box
                component="span"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },

                  fontWeight: 600,
                }}
              >
                <CurrencyRupeeIcon
                  sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                />
                {totalAmount(formda?.componentDetails)}
              </Box>
            </Box>
            <Divider
              sx={{
                background: (theme) => theme.palette.primary.main,
                width: "100%",
                mt: 1,
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ padding: "15px 100px" }}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                fontWeight: 600,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              onClick={() => {
                addUpdateApi(formda);
              }}
            >
              {formda?.id ? "Update" : "Save"}
            </Button>
          </Grid>
        </Grid>
        <PoprchModal
          cardValue={cardValue}
          setCardValue={(data) => {
            setSearchvalue(data?.name);
            setCardValue(data);
            setFormda({ ...formda, empId: data.id });
          }}
          callback={() => {}}
          searchModal={searchModal}
          setSearchModal={setSearchModal}
          config={{
            salary: true,
          }}
        />
      </Box>
    </Modal>
  );
}
